import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import axios from "axios";
import { baseUrl } from "../../../Utility/constants";
import "./SchoolDetails.css";
import { formatDateToDDMMYYYY } from "../../../Utility/constants";
import { Link } from "react-router-dom";

const SchoolDetailsModal = ({ show, handleDetailsClose, schoolData }) => {
  const [grantTypes, setGrantTypes] = useState([]);
  const [attachTypes, setAttachTypes] = useState([]);
  const [streams, setStreams] = useState([]);

  // Fetch Grant Types, Attach Types, and Streams on component load
  useEffect(() => {
    const fetchGrantTypes = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/CommonMaster/GetGrantTypeMasters`
        );
        setGrantTypes(response.data);
      } catch (error) {
        console.error("Error fetching Grant Types", error);
      }
    };

    const fetchAttachTypes = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/CommonMaster/GetAttachTypeMasters`
        );
        setAttachTypes(response.data);
      } catch (error) {
        console.error("Error fetching Attach Types", error);
      }
    };

    const fetchStreams = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/StreamMaster`);
        setStreams(response.data);
      } catch (error) {
        console.error("Error fetching Streams", error);
      }
    };

    fetchGrantTypes();
    fetchAttachTypes();
    fetchStreams();
  }, []);

  // Helper function to get name by ID
  const getNameById = (list, id) => {
    const item = list.find((el) => el.id === parseInt(id, 10)); // Parse ID to integer
    return item ? item.name : "N/A";
  };

  // Helper function to handle comma-separated IDs
  const getNamesFromIds = (list, ids) => {
    if (!ids) return "N/A"; // Handle empty or undefined cases
    return ids
      .split(",")
      .map((id) => getNameById(list, id.trim()))
      .join(", ");
  };

  return (
    <Modal
      show={show}
      onHide={handleDetailsClose}
      dialogClassName="custom-modal-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>School Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {schoolData ? (
          <Container>
            <Row className="mb-3">
              <Col md={3}>
                <strong>Organization Name:</strong>
                <br></br>
                {schoolData.organizationName !== null
                  ? schoolData.organizationName
                  : "N/A"}
              </Col>
              <Col md={3}>
                <strong>Establishment Year:</strong>
                <br></br>
                {schoolData.establishmentYear !== null
                  ? schoolData.establishmentYear
                  : "N/A"}
              </Col>
              <Col md={3}>
                <strong>School/College Name:</strong>
                <br></br>
                {schoolData.schoolOrCollegeName !== null
                  ? schoolData.schoolOrCollegeName
                  : "N/A"}
              </Col>
              <Col md={3}>
                <strong>Location:</strong>
                <br></br>
                {schoolData.location !== null ? schoolData.location : "N/A"}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={3}>
                <strong>UDISE No:</strong>
                <br></br>
                {schoolData.udiseNo !== null ? schoolData.udiseNo : "N/A"}
              </Col>
              <Col md={3}>
                <strong>10th Index No:</strong>
                <br></br>
                {schoolData.ssC10thIndexNo !== null
                  ? schoolData.ssC10thIndexNo
                  : "N/A"}
              </Col>
              <Col md={3}>
                <strong>12th Index No:</strong>
                <br></br>
                {schoolData.hsC12thIndexNo !== null
                  ? schoolData.hsC12thIndexNo
                  : "N/A"}
              </Col>
              <Col md={3}>
                <strong>Grant Types:</strong>
                <br></br>
                {getNamesFromIds(grantTypes, schoolData.grantTypes)}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={3}>
                <strong>Streams:</strong>
                <br></br>
                {getNamesFromIds(streams, schoolData.streams)}
              </Col>
              <Col md={3}>
                <strong>School Type:</strong>
                <br></br>
                {schoolData.schoolType !== null ? schoolData.schoolType : "N/A"}
              </Col>
              <Col md={3}>
                <strong>Attach Types:</strong>
                <br></br>
                {getNamesFromIds(attachTypes, schoolData.attachTypes)}
              </Col>
              <Col md={3}>
                <strong>School Timing:</strong>
                <br></br>
                {schoolData.schoolOrCollegeTiming !== null
                  ? schoolData.schoolOrCollegeTiming
                  : "N/A"}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={3}>
                <strong>Is Night School:</strong>
                <br></br>
                {schoolData.isNightSchoolOrCollege === true ? "YES" : "NO"}
              </Col>
              <Col md={3}>
                <strong>IT:</strong>
                <br></br>
                {schoolData.it ? "Yes" : "No"}
              </Col>
              <Col md={3}>
                <strong>Bifocal:</strong>
                <br></br>
                {schoolData.bifocal ? "Yes" : "No"}
              </Col>

              <Col md={3}>
                <strong>Minority:</strong>
                <br></br>
                {schoolData.minority ? "Yes" : "No"}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={3}>
                <strong>Minority Type:</strong>
                <br></br>
                {schoolData.minorityType !== null
                  ? schoolData.minorityType
                  : "N/A"}
              </Col>
              <Col md={3}>
                <strong>Address:</strong>
                <br></br>
                {schoolData.address !== null ? schoolData.address : "N/A"}
              </Col>

              <Col md={3}>
                <strong>Pincode:</strong>
                <br></br>
                {schoolData.pincode !== null ? schoolData.pincode : "N/A"}
              </Col>
              <Col md={3}>
                <strong>School Recognition Number:</strong>
                <br></br>
                {schoolData.schoolRegistrationNumber !== null
                  ? schoolData.schoolRegistrationNumber
                  : "N/A"}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={3}>
                <strong>School Recognition Date:</strong>
                <br></br>
                {schoolData.schoolRegistrationDate != null &&
                  schoolData.schoolRegistrationDate != undefined &&
                  formatDateToDDMMYYYY(schoolData.schoolRegistrationDate)}
              </Col>
              <Col md={3}>
                <strong>College Recognition Number:</strong>
                <br></br>
                {schoolData.collegeRegistrationNumber !== null
                  ? schoolData.collegeRegistrationNumber
                  : "N/A"}
              </Col>
              <Col md={3}>
                <strong>College Recognition Date:</strong>
                <br></br>
                {schoolData.collegeRegistrationDate != null &&
                  schoolData.collegeRegistrationDate != undefined &&
                  formatDateToDDMMYYYY(schoolData.collegeRegistrationDate)}
              </Col>
              <Col md={3}>
                <strong>Principal Name:</strong>
                <br></br>
                {schoolData.principalName !== null
                  ? schoolData.principalName
                  : "N/A"}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={3}>
                <strong>Principal Contact No:</strong>
                <br></br>
                {schoolData.principalContactNo !== null
                  ? schoolData.principalContactNo
                  : "N/A"}
                <br></br>
                <br></br>
                <strong>School Medium:</strong>
                <br></br>
                {schoolData.schoolMediumNames ? schoolData.schoolMediumNames : "N/A"}
              </Col>
              <Col md={3}>
                <strong>Email:</strong>
                <br></br>
                {schoolData.email !== null ? schoolData.email : "N/A"}
                <br></br>
                <br></br>
                <strong>Session:</strong>
                <br></br>
                {/* {schoolData.sessionName? schoolData.sessionName : "N/A"} */}
                <ul>
                  {schoolData?.sessionName &&
                  schoolData.sessionName.length > 0 ? (
                    schoolData.sessionName
                      .split(", ")
                      .map((session, index) => <li key={index}>{session}</li>)
                  ) : (
                    <li>N/A</li>
                  )}
                </ul>
              </Col>
              <Col md={3}>
                <strong>ERP Web link: </strong> <br></br>
                {schoolData.websiteName === null ||
                schoolData.websiteName === undefined ? (
                  "N/A"
                ) : (
                  <Link
                    to={
                      schoolData.websiteName != null &&
                      schoolData.websiteName != undefined &&
                      schoolData.websiteName
                    }
                    target="_blank"
                  >
                    {schoolData.websiteName}
                  </Link>
                )}
                <br></br>
                <br></br>
                <strong>LC Naming:</strong>
                <br></br>
                {schoolData.lcNamingPrint === true
                  ? "Last-First-Middle"
                  : "First-Middle-Last"}
              </Col>
              <Col md={3}>
                <strong>Website link: </strong> <br></br>
                {
                schoolData.schoolWebsiteName === null || schoolData.schoolWebsiteName === undefined ? (
                  "N/A"
                ) : 
                 <Link
                    to={
                      schoolData.schoolWebsiteName != null &&
                      schoolData.schoolWebsiteName != undefined &&
                      schoolData.schoolWebsiteName
                    }
                    target="_blank"
                  >
                    {schoolData.schoolWebsiteName}
                  </Link>
                }
                <br></br>
              </Col>

              <Col md={3}>
                <strong>Logo : </strong>
                {schoolData.logo ? (
                  <Link
                    to={schoolData.logo}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={schoolData.logo}
                      alt="Student Photo"
                      style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "11px",
                      }}
                    />
                  </Link>
                ) : (
                  "Not Uploaded"
                )}
              </Col>
              <Col md={3}>
                <strong>Signature : </strong>
                {schoolData.principalSignture ? (
                  <Link
                    to={schoolData.principalSignture}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={schoolData.principalSignture}
                      alt="Principal Signture"
                      style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "11px",
                      }}
                    />
                  </Link>
                ) : (
                  "Not Uploaded"
                )}
              </Col>
              <Col md={3}>
                <strong>Stamp : </strong>
                {schoolData.schoolCollegeStamp ? (
                  <Link
                    to={schoolData.schoolCollegeStamp}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={schoolData.schoolCollegeStamp}
                      alt="School College Stamp"
                      style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "11px",
                      }}
                    />
                  </Link>
                ) : (
                  "Not Uploaded"
                )}
              </Col>
            </Row>
            <Row className="mb-3"></Row>
          </Container>
        ) : (
          <p>No details available</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleDetailsClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SchoolDetailsModal;
